export default __webpack_public_path__ + "static/media/img3.e0337cc3.jpg";